import type { Conversation } from '../models/copilot.models';

/**
 * Known chat suggestion agent ids for consumer fetch and admin filter/create dropdowns.
 * Aligns with BrightNav agent metadata `agent_id` values.
 */
export const CHAT_SUGGESTION_AGENT_IDS = ['brightnav', 'content'] as const;

export type ChatSuggestionAgentId = (typeof CHAT_SUGGESTION_AGENT_IDS)[number];

/** Default FA / BrightNav copilot agent for suggestion chips. */
export const BRIGHTNAV_AGENT_CONFIG = {
  agentId: 'brightnav' as ChatSuggestionAgentId,
};

/**
 * Resolves which suggestion API `agentId` to use for a conversation.
 *
 * @remarks Only metadata values in {@link CHAT_SUGGESTION_AGENT_IDS} are honored; other agent ids
 * (e.g. legacy copilot names) fall back to {@link BRIGHTNAV_AGENT_CONFIG} so chips still load.
 *
 * @param conversation Selected conversation row from the store, if loaded.
 * @returns Agent id for `GET …/chat/suggestions?agentId=…`.
 */
export function resolveChatSuggestionAgentId(
  conversation: Conversation | null | undefined
): ChatSuggestionAgentId {
  const metaAgentId = conversation?.metadata?.['agent_id'];
  if (typeof metaAgentId === 'string') {
    const trimmed = metaAgentId.trim();
    if ((CHAT_SUGGESTION_AGENT_IDS as readonly string[]).includes(trimmed)) {
      return trimmed as ChatSuggestionAgentId;
    }
  }
  return BRIGHTNAV_AGENT_CONFIG.agentId;
}
